module.exports = __webpack_public_path__ + "static/copy.bc508ca7.svg";